import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { logoutUser } from "./AccountLogoutThunk";

const API_BASE = process.env.REACT_APP_API_URL;
// Thunk to fetch referrals for the logged-in member
export const fetchOnboardingReferrals = createAsyncThunk(
  "onboardingReferrals/fetchAll",
  async (_, thunkAPI) => {
    try {
      const res = await fetch(`${API_BASE}/api/onboarding-referrals/all`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "admin",
        },
      });

      if (res.status === 401) {
        thunkAPI.dispatch(logoutUser());
        window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
        return thunkAPI.rejectWithValue("Unauthorized");
      }

      const json = await res.json();

      if (!res.ok) {
        return thunkAPI.rejectWithValue(
          json?.message || "Failed to fetch referrals"
        );
      }
      const transformed = (json.data || []).map((item) => ({
        id: item._id,
        referrerID: item.referrer_id?._id,
        referredBy: `${item.referrer_id.first_name} ${item.referrer_id.last_name}`,
        member: `${item.referred_id.first_name} ${item.referred_id.last_name}`,
        memberType: ` ${item.referred_id.member_type}`,
        successfulReferrals:
          item.reward_status === "pending"
            ? "Signed Up"
            : "Successful referral",
      }));

      return transformed;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message || "Network error");
    }
  }
);
export const fetchOnboardingReferralsByID = createAsyncThunk(
  "onboardingReferrals/fetchByID",
  async (id, thunkAPI) => {
    try {
      const res = await fetch(
        `${API_BASE}/api/onboarding-referrals/all?referrer_id=${id}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "x-user-role": "admin",
          },
        }
      );

      if (res.status === 401) {
        thunkAPI.dispatch(logoutUser());
        window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
        return thunkAPI.rejectWithValue("Unauthorized");
      }

      const json = await res.json();

      if (!res.ok) {
        return thunkAPI.rejectWithValue(
          json?.message || "Failed to fetch referrals"
        );
      }

      // Transform API response into flat table rows
      const transformed = (json.data || []).map((item) => ({
        friend_name: `${item.referred_id?.first_name || ""} ${
          item.referred_id?.last_name || ""
        }`.trim(),
        friend_email: item.referred_id?.email_address || "-",
        reward: item.reward_history_id
          ? `${item.reward_history_id.reward_amount}`
          : `${item.reward_amount}`,
        reward_status: item.reward_status || "-",
        date_referred: item.created_at,
      }));

      return transformed;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message || "Network error");
    }
  }
);

const onboardingReferralsSlice = createSlice({
  name: "onboardingReferrals",
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOnboardingReferrals.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOnboardingReferrals.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload || [];
      })
      .addCase(fetchOnboardingReferrals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchOnboardingReferralsByID.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOnboardingReferralsByID.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload || [];
      })
      .addCase(fetchOnboardingReferralsByID.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default onboardingReferralsSlice.reducer;
